import "react-datepicker/dist/react-datepicker.css";

import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Form, Button, Modal, Spinner, InputGroup } from "react-bootstrap";
import { DatesAndGuests } from "../../widget-form/WidgetForm";
import momentjs from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { WidgetContext } from "../../../../../context/WidgetContext";
import { Modifier } from "react-day-picker";
import useCreateQuote, { CreateQuoteRequest } from "../data-service-hooks/UseCreateQuote";
import Quote from "../../../../../Data/Quote/Quote";
import Customer from "../../../../../Data/Customer/Customer";
import { yupResolver } from "@hookform/resolvers";
import { useForm } from "react-hook-form";
import { RequestQuoteFormData, RequestQuoteSchema, RequestQuoteSchemaDefaultValues } from "./schemas/RequestQuoteSchema";
import { RBRef } from "../../../../../_helpers/Types";
import { ReservationCustomer } from "../../../../../Data/Reservation/ReservationCustomer";
import moment from "moment";
import ViewPort from "../../../../../_helpers/Enums/ViewPortEnum";
import { toast } from "react-toastify";
import CustomDayPickerInput from "../../../customDayPickerInput/CustomDayPickerInput";
import { EnumQuoteLeadSource } from "../../../../../_helpers/Enums/EnumQuoteLeadSource";
import * as yup from "yup";
// import DatePicker from "react-datepicker";

interface props {
  show: boolean;
  onHide: () => void;
  datesAndGuests: DatesAndGuests;
  isGroup?: boolean;

}

// pull this out of the component since it never needs to be recalculated on re-render
const extendedSchema = yup.object().shape({
  ...RequestQuoteSchema.fields,
  needLodging: yup.string().required("You must select one lodging choice").oneOf(["Hotel", "Condo", "Private Home", "No Lodging"], "Must select one lodging choice")
});

type RequestQuoteExtendedFormData = yup.InferType<typeof extendedSchema>

const RequestQuoteModal: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint, companyId, /* brandId */brand } = useContext(WidgetContext);

  const { show, onHide, isGroup } = props;
  const [datesAndGuests, setDatesAndGuests] = useState<DatesAndGuests>(props.datesAndGuests);
  const { formatDate, parseDate } = momentjs;
  const modifiers = { start: datesAndGuests.fromDate, end: datesAndGuests.toDate };

  const [createRequest, setCreateRequest] = useState<CreateQuoteRequest>();
  const createResponse = useCreateQuote(createRequest);

  // const [validated, setValidated] = useState<boolean>(false);
  const { register, handleSubmit, errors, formState, setValue, reset, getValues } = useForm<RequestQuoteExtendedFormData>({
    mode: "onSubmit",
    resolver: yupResolver(extendedSchema),
    defaultValues: {...RequestQuoteSchemaDefaultValues, needLodging: "", numGuests: isGroup ? 16 : 2}
  });

  const submit = (formData: RequestQuoteExtendedFormData) => {
    const customer: ReservationCustomer = {
      reservationId: 0,
      customerId: 0,
      customer: {
        companyId: companyId as number,
        customerId: 0,
        isActive: true,
        firstName: formData.firstName,
        lastName: formData.lastName,
        emailAddress: formData.email,
        streetAddress: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        phone1: formData.phone,
        customerNotes: formData.comments + "\n Customer Lodging Preference: " + formData.needLodging,
      },
      paymentAllocationCategoryId: undefined,
      paymentAllocationCategory: undefined,
      cancelled: false
    };

    const quote: Quote = {
      reservation: {
        companyId: companyId as number,
        brandId: brand?.brandId,
        leadCustomer: undefined,
        itineraryNumber: "",
        lodgingItineraries: [],
        golfItineraries: [],
        transportItineraries: [],
        customItineraries: [],
        numGuests: datesAndGuests.guests,
        numChildren: 0,
        totalSell: 0.0,
        totalCost: 0.0,
        balanceDue: 0.0,
        arrive: moment(datesAndGuests.fromDate).format("YYYY-MM-DD"),
        depart: moment(datesAndGuests.toDate).format("YYYY-MM-DD"),
        tax: 0.0,
        resortFees: 0.0,
        cleaningFee: 0.0,
        groupName: !!!formData.groupName ? undefined : {
          companyId: companyId as number,
          name: formData.groupName
        },
        isPreBuiltPkg: false,
        reservationCustomers: [customer]
      },
      requestNote: formData.comments + "\n Customer Lodging Preference: " + formData.needLodging,
      quoteLeadSourceId: isGroup ? EnumQuoteLeadSource.OnlineGroupQuote : EnumQuoteLeadSource.OnlineQuote,
    };

    setCreateRequest(quote);
  }

  useEffect(() => {
    if (createResponse.data) {
      // console.log("CREATE RESPONSE", createResponse.data);
      onHide();
      // alert("A reservation agent will get in touch with you");
      toast.success("A reservation agent will get in touch with you", { hideProgressBar: false });
    }
  }, [createResponse.data]);

  useEffect(() => {
    if (createResponse.error) {
      console.log("request quote error", createResponse.error);
      onHide();
      // alert("Error requesting a quote");
      toast.error("Error requesting a quote", { hideProgressBar: false });
    }
  }, [createResponse.error]);

  return (
    <React.Fragment>
      <Modal
        scrollable={true}
        size="lg"
        show={show}
        onHide={onHide}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header translate="" closeButton closeLabel="close window">
          <div className="w-100">
            <Modal.Title style={{ color: style.fontColor }}>Request Quote</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row className="d-flex justify-content-center p-0 m-0">
            <Col className="p-0 m-0" xs={12}>
              {/* Header */}
              <div style={{ fontFamily: "Istok Web sans-serif" }}>
                <Form className="widget-font" noValidate onSubmit={handleSubmit(submit)}>
                  <div className="m-0 p-0 mb-3">
                    <Form.Row>
                      <Col>
                        <p
                          className="widget-font"
                          style={{
                            color: style.fontColor,
                            fontWeight: "bold",
                            fontSize: "15px",
                          }}
                        >
                          Step 1: Input contact info for your custom quote.
                        </p>
                      </Col>
                    </Form.Row>
                    {/* Contact Info */}
                    <Form.Row>
                      <Col>
                        {/* <Form.Label style={{ fontWeight: "bold", color: style.fontColor }}>
                        First Name
                      </Form.Label> */}
                        <Form.Control
                          style={{ color: style.fontColor }}
                          className="box-shadow"
                          name="firstName"
                          type="text"
                          placeholder="First Name"
                          // value={firstName}
                          // onChange={textChange}
                          ref={register({ required: true }) as RBRef}
                          isValid={formState.isSubmitted && !errors.firstName}
                          isInvalid={formState.isSubmitted && (!!errors.firstName)}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors.firstName && errors.firstName.message}
                        </Form.Control.Feedback>
                      </Col>
                      <Col>
                        {/* <Form.Label style={{ fontWeight: "bold", color: style.fontColor }}>
                        Last Name
                      </Form.Label> */}
                        <Form.Control
                          style={{ color: style.fontColor }}
                          className="box-shadow"
                          name="lastName"
                          type="text"
                          placeholder="Last Name"
                          // value={lastName}
                          // onChange={textChange}
                          ref={register({ required: true }) as RBRef}
                          isValid={formState.isSubmitted && !errors.lastName}
                          isInvalid={formState.isSubmitted && (!!errors.lastName)}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors.lastName && errors.lastName.message}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Row>
                    <Form.Row style={{ marginTop: "15px" }}>
                      <Col>
                        {/* <Form.Label style={{ fontWeight: "bold", color: style.fontColor }}>
                        Email Address
                      </Form.Label> */}
                        <Form.Control
                          style={{ color: style.fontColor }}
                          className="box-shadow"
                          name="email"
                          type="text"
                          placeholder="Email Address"
                          // value={email}
                          // onChange={textChange}
                          ref={register({ required: true }) as RBRef}
                          isValid={formState.isSubmitted && !errors.email}
                          isInvalid={formState.isSubmitted && (!!errors.email)}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors.email && errors.email.message}
                        </Form.Control.Feedback>
                      </Col>
                      <Col>
                        {/* <Form.Label style={{ fontWeight: "bold", color: style.fontColor }}>
                        Contact Phone
                      </Form.Label> */}
                        <Form.Control
                          style={{ color: style.fontColor }}
                          className="box-shadow"
                          name="phone"
                          placeholder="Phone Number"
                          // value={phone}
                          // onChange={textChange}
                          ref={register({ required: true }) as RBRef}
                          isValid={formState.isSubmitted && !errors.phone}
                          isInvalid={formState.isSubmitted && (!!errors.phone)}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors.phone && errors.phone.message}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Row>

                    {isGroup && (
                      <Form.Row style={{ marginTop: "15px" }}>
                        <Col xs={6}>
                          {/* <Form.Label style={{ fontWeight: "bold", color: style.fontColor }}>
                          Group Name
                        </Form.Label> */}
                          <Form.Control
                            style={{ color: style.fontColor }}
                            className="box-shadow"
                            name="groupName"
                            type="text"
                            placeholder="Group Name"
                            // value={groupName}
                            // onChange={textChange}
                            ref={register}
                            isValid={formState.isSubmitted && !errors.groupName}
                            isInvalid={formState.isSubmitted && (!!errors.groupName)}
                          />

                          {/* <Form.Control.Feedback type="invalid">
                          {errors.groupName && errors.firstName.message}
                        </Form.Control.Feedback> */}
                        </Col>
                      </Form.Row>
                    )}
                  </div>

                  {/* Step 2 */}
                  <Row className="widget-font">
                    <Col>
                      <p
                        style={{
                          color: style.fontColor,
                          fontWeight: "bold",
                          fontSize: "15px"
                        }}
                      >
                        Step 2: What dates do you plan to arrive/depart, and how many people are with you?
                      </p>
                    </Col>
                  </Row>

                  {/* Dates */}
                  <Form.Row>
                    {/* DAY PICKERS */}
                    {/* <div className="InputFromTo" style={{ marginRight: "10px" }}> */}
                    <Col xs={12} md={6} className="InputFromTo d-flex flex-column mb-2">
                      {/* <Form.Label className="font-weight-bold" style={{ color: style.fontColor }}>
                          Arrive
                        </Form.Label> */}
                      <CustomDayPickerInput
                        value={`Arrive: ${moment(datesAndGuests.fromDate).format("ddd, MMM Do, YYYY")}`}
                        placeholder="From"
                        format="LL"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        inputProps={{ required: "required", style: { color: style.fontColor, paddingLeft: "10px" } }}
                        dayPickerProps={{
                          selectedDays: { from: datesAndGuests.fromDate, to: datesAndGuests.toDate } as Modifier,
                          disabledDays: { before: new Date() },
                          month: datesAndGuests.fromDate,
                          modifiers,
                          numberOfMonths: 1,
                          // onDayClick: () => this.to.getInput().focus(),
                        }}
                        onDayChange={(date: Date) => {
                          datesAndGuests.fromDate = date;
                          if (datesAndGuests.toDate && date > datesAndGuests.toDate) {
                            datesAndGuests.toDate = date;
                          }
                          setDatesAndGuests({ ...datesAndGuests });
                        }}
                      />
                    </Col>
                    {/* </div> */}

                    {/* <div className="InputFromTo" style={{ marginRight: "10px" }}> */}
                    <Col xs={12} md={6} className="InputFromTo d-flex flex-column mb-3">
                      {/* <Form.Label className="font-weight-bold" style={{ color: style.fontColor }}>
                          Depart
                        </Form.Label> */}
                      <CustomDayPickerInput
                        value={`Depart: ${moment(datesAndGuests.toDate).format("ddd, MMM Do, YYYY")}`}
                        placeholder="To"
                        format="LL"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        inputProps={{ required: "required", style: { color: style.fontColor, paddingLeft: "10px" } }}
                        dayPickerProps={{
                          selectedDays: { from: datesAndGuests.fromDate, to: datesAndGuests.toDate } as Modifier,
                          disabledDays: { 
                            before: datesAndGuests.fromDate as Date,
                            after: moment(datesAndGuests.fromDate).add(14, 'days').toDate()
                          },
                          modifiers,
                          month: datesAndGuests.fromDate,
                          fromMonth: datesAndGuests.fromDate,
                          numberOfMonths: 1
                        }}
                        onDayChange={(date: Date) => {
                          datesAndGuests.toDate = date;
                          setDatesAndGuests({ ...datesAndGuests });
                        }}
                      />
                    </Col>
                    {/* </div> */}
                    </Form.Row>

                    <Form.Row>
                      <Col xs={12} md={6} className="mb-2">
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text 
                              style={{
                                color: style.fontColor,
                                backgroundColor: 'white',
                                paddingLeft: '10px'
                              }}
                            >
                              Guests:
                            </InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            style={{
                              color: style.fontColor,
                              paddingLeft: "6px"
                            }}
                            name="numGuests"
                            type="number" 
                            min={isGroup ? "16" : "1"}
                            max={isGroup ? "144" : "16"}
                            className="guest-select"
                            value={datesAndGuests.guests}
                            ref={register({ required: true }) as RBRef}
                            isValid={formState.isSubmitted && !errors.numGuests}
                            isInvalid={formState.isSubmitted && (!!errors.numGuests)}
                            onChange={(e) => {
                              datesAndGuests.guests = parseInt(e.target.value);
                              setDatesAndGuests({ ...datesAndGuests });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.numGuests && errors.numGuests.message}
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Col>
                      <Col xs={12} md={6} className="mb-3">
                      {/* <Row
                        className="justify-content-start"
                        style={{ paddingRight: "16px" }}
                      > */}
                        <Form.Control
                          style={{ color: style.fontColor, width: "100%", paddingLeft: "6px" }}
                          name="needLodging"
                          as="select"
                          ref={register({ required: true }) as RBRef}
                          isValid={formState.isSubmitted && !errors.needLodging}
                          isInvalid={formState.isSubmitted && (!!errors.needLodging)}
                        >
                          <option value="" disabled hidden>Please Select a Lodging Choice</option>
                          <option value="Hotel">Hotel</option>
                          <option value="Condo">Condo</option>
                          <option value="Private Home">Private Home</option>
                          <option value="No Lodging">No Lodging</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.needLodging && errors.needLodging.message}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Row>

                  {/* Step 3 */}
                  <Row className="widget-font">
                    <Col>
                      <p
                        style={{
                          color: style.fontColor,
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        Step 3: Let us know in detail below what you are looking for in this quote, and if you have any specific requests, or properties to include.
                      </p>
                    </Col>
                  </Row>
                  <Form.Row>
                    <Col>
                      <Form.Control
                        style={{ color: style.fontColor }}
                        as="textarea"
                        rows={6}
                        name="comments"
                        className="box-shadow"
                        placeholder="Please Include Below: Detail of what you want to experience on your trip, so we can include the best properties and quote for your needs.
Do you need: Best of The Best, Middle of The Road, or Best Value Package"
                        // value={comments}
                        // onChange={textChange}
                        ref={register}
                        isValid={formState.isSubmitted && !errors.comments}
                        isInvalid={formState.isSubmitted && (!!errors.comments)}
                      />

                      {/* <Form.Control.Feedback type="invalid">
                        {errors.comments && errors.firstName.message}
                      </Form.Control.Feedback> */}
                    </Col>
                  </Form.Row>
                  <Button
                    className="widget-font"
                    variant="primary"
                    disabled={createResponse.isLoading}
                    size="lg"
                    block
                    style={{ backgroundColor: style.buttonColor, marginTop: "100px" }}
                    type="submit"
                  // onClick={submit}
                  >
                    <Row className="justify-content-center align-items-center">
                      {createResponse.isLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      {createResponse.isLoading ? "Saving..." : "Save & Get Quote"}
                    </Row>
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

    </React.Fragment>
  );
}

export default RequestQuoteModal;